module.exports = __webpack_public_path__ + "img/pftp-64x64.774bc07c.png";